import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.decimal", function() {

    var expose = {};

    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function($scope, element, attributes, controller) {

        var getDecimalValue = function(value) {
            var parsedValue = "";
            var temporaryValue;
            var integralPart;
            var decimalPart;
            if (value) {
                parsedValue = value.replace(/[^0-9.]/g, ""); // strip anything thats not a number or a full stop
                temporaryValue = parsedValue.split(".");
                if (temporaryValue.length > 1) {
                    // put the decimal place back again
                    integralPart = temporaryValue.shift();
                    decimalPart = temporaryValue.join("");
                    if (attributes.decimalPrecision) {
                        decimalPart = decimalPart.substring(0, parseInt(attributes.decimalPrecision));
                    }
                    parsedValue = integralPart + "." + decimalPart;
                }
            }
            return parsedValue;
        };

        controller.$parsers.unshift(function(value) {
            var decimalValue = getDecimalValue(value);
            if (decimalValue !== value) {
                controller.$setViewValue(decimalValue);
                controller.$render();
            }
            return decimalValue;
        });

        controller.$formatters.unshift(function(value) {
            return getDecimalValue(value);
        });

    };

    return expose;

});
